import React, {useContext, useState, useEffect} from 'react'
import {RULE_STATUS} from "../../helpers/options"
import SettingShippingRuleContext from '../context/SettingShippingRuleContext'
import FilterOptions from "../../../components/InputSelect/FilterOptions"
import SearchGroup from "../../../components/InputSelect/SearchGroup"
import { getListShippingCarrier } from '../../../services/api/apiShippingCarrier'
import {Select} from 'antd'
import { canViewStoreName } from '../../../services/StorageServices'

const SettingShippingRuleFilters = (props) => {
    const canViewStore = canViewStoreName()
    const {platforms} = props
    const {filters, setState} = useContext(SettingShippingRuleContext)
    const [listShippingCarrier, setListShippingCarrier] = useState([])
    const [allShippingCarrier, setAllShippingCarrier] = useState([])

    const options = [
        {title: 'SKU', key: 'type', value: filters.sku || ''},
        {title: 'Country', key: 'country', value: filters.country || ''},
        {title: 'State', key: 'state', value: filters.state || ''},
        ...(canViewStore ? [{title: 'Store', key: 'store', value: filters.store || ''}] : []),
        {title: 'Tag', key: 'tag', value: filters.tag || ''},
    ]

    const _handleChangeFilterGroupState = (paramFilter) => {
        const _filters = {
            ...filters,
            ...paramFilter
        }

        for (let i=0;i<options.length;i++) {
            if(options[i].key !== Object.keys(paramFilter)[0]) delete _filters[options[i].key]
        }

        if(Object.values(paramFilter)[0].length === 0) delete _filters[Object.keys(paramFilter)[0]]
        setState(_filters)
    }

    const _handleChangeFilterState = (paramFilter) => {
        const _filters = {
            ...filters,
            ...paramFilter
        }
        if(Object.values(paramFilter)[0] === '') delete _filters[Object.keys(paramFilter)[0]]
        setState(_filters)
    }

    const fetchFiltersShippingCarrier = async(payload) => {
        try {
            const newPayload = {
                ...payload,
                limit: 10000,
                page: 1,
            }

            const res = await getListShippingCarrier(newPayload)
            const {data, success, message} = {...res}
            if (!success) {
                throw new Error(message)
            }
            const shippingCarriers = !!data.shippingCarriers && data.shippingCarriers.length > 0 ? data.shippingCarriers.sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
            }) : []
            setListShippingCarrier(shippingCarriers.filter(i => !!i.is_active) || [])
            setAllShippingCarrier(shippingCarriers || [])
            
        } catch (error) {
            alert(error.message)
        }
    } 

    useEffect(()=>{
        fetchFiltersShippingCarrier()
    },[])

    const shippingCarrierOption = !!listShippingCarrier && listShippingCarrier.length > 0 ? listShippingCarrier.map(i=> ({
        value: i.slug,
        name: i.name,
        is_active: i.is_active,
    })) : []
    const {Option} = Select

    return (
        <div className="d-flex">
            <div className="itemFilterGroup mb-3 mr-3">
                <label className="mb-1 Heading">Store</label>
                <SearchGroup options={options} onSearch={_handleChangeFilterGroupState}/>
            </div>
            <div className="itemFilter mr-3 mb-3">
                <FilterOptions onChangeOption={_handleChangeFilterState} selectedKey={filters.platform || ''} field='platform'
                               placeHolder="All platform"
                               options={platforms} layout='select' heading='Platform:' defaultOption={''}
                               allowClear={true}/>
            </div>
            <div className="itemFilter mr-3 mb-3">
                {/* <FilterOptions onChangeOption={_handleChangeFilterState} selectedKey={filters.shipping_carrier || ''} field='shipping_carrier'
                               placeHolder="All shipping carrier"
                               options={shippingCarrierOption} layout='select' heading='Shipping carrier:' defaultOption={''}
                               allowClear={true}/> */}
                <div className={'FilterOptions'}>
                    <div className='mb-1 Heading'>Shipping carrier:</div>
                    <Select onChange={(value)=>_handleChangeFilterState({shipping_carrier: value === undefined ? '' : value})}
                        style={{ width: '100%' }} value={filters.shipping_carrier || []} 
                        placeholder={"All shipping carrier"}
                        allowClear={true}
                        showSearch
                        onSearch={(value) => {
                            if(value) {
                                const newList = allShippingCarrier.filter(i => !!i.name.toLowerCase().includes(value.toLowerCase()))
                                setListShippingCarrier(newList)
                            }else {setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active))}
                        }}
                        onBlur={() => setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active))}
                        filterOption={(input, option) => {
                            return option.children.toLowerCase().includes(input.toLowerCase())
                        }}
                    >
                        {shippingCarrierOption.map((option, index) => (
                            <Option key={`${'shipping_carrier'}_${option.value}_${index + 1}`} value={option.value} style={!option.is_active ? {} : { color: '#333' }}>{option.name}</Option>
                        ))}
                    </Select>
                </div>
            </div>
            <div className="itemFilter mr-3 mb-3">
                <FilterOptions onChangeOption={_handleChangeFilterState} selectedKey={filters.status || ''} field='status'
                               placeHolder="All status"
                               options={RULE_STATUS} layout='select' heading='Status:' defaultOption={''}
                               allowClear={true}/>
            </div>
        </div>
    )
}

export default SettingShippingRuleFilters
